export default "__VITE_ASSET__Cp50eoI0__$_?url__"